<template>
    <div>
        <div class="modal-container">
            <div class="notification ">
                <button id="xButt" class="delete" @click="$emit('close')"></button>
                <div id="title" class="bottom10">Alert</div> 
                {{message}}
                <div class="body-bott has-text-right">
                   
                    <button  class="button is-coolGreen" @click="ok(1)">
                            MOVE
                    </button>
                    &nbsp;
                     <button class="button is-coolGreen" @click="ok(2)">
                            COPY
                    </button>
                    &nbsp;
                    <button class="button " @click="cancel">
                            CANCEL
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: {message: String, callBack: Function, payload: Object, fromTreeMover: Boolean},
  methods: {
      ok: function(what){
          this.payload.what = what
          let b = {}
          if(this.callBack && what == 2){
            this.callBack(this.payload)
            return
          } else if(what == 1) {
              for(var x=0; x<this.$root.app.bundles.length; x++){
                  if(this.$root.app.bundles[x].id == this.payload.data.draggedId){
                      b = this.$root.app.bundles[x]
                      break
                  }

              }

              var theIndex = this.payload.index;
              if(this.payload.index ==  'last'){
                  for(var n=0; n<this.$root.app.bundles.length; n++){
                      if(this.$root.app.bundles[n].id == this.payload.targetId){
                          theIndex = this.$root.app.bundles[n].children.length
                          break;
                      }
                  }
              }
              
              if(this.payload.levelUp){
                if(this.payload.branch.length > 0){
                    this.payload.levelUp()
                } else {
                    let ind = this.$root.app.treeNoInbox.findIndex(e => {
                        return e.id == this.payload.data.draggedId;
                    })
                    this.$root.app.treeNoInbox.splice(ind, 1)
                }
              }
                    
             //console.log(this.payload.data.bundleId, this.payload.targetId, this.payload.index, b, this.$root.app, this.payload.branch, null, null, this.payload.aliasTgtId)
              this.$root.app.bundleMover(this.payload.data.bundleId || 'root', this.payload.targetId, theIndex, b, this.$root.app, this.payload.branch, this.payload.data.listIndex, null, null, this.payload.aliasTgtId, this.payload.collabId)
              
          } 
          this.$emit('close')
          
      },
      cancel: function(){
          this.$emit('close')
      }
  }
}
</script>

<style scoped>
    #title{
    font-size: 1.5rem;
    }
    .modal-container{
        width: 350px;
        height: 250px;
        background: #000
    }
    .body-bott{
        position: absolute;
        right: 15px;
        bottom: 20px;
        width: 100%;
    }
    .body-bott .button{
       /*  position: absolute;
        right: 30px;
        bottom: 10px; */
    }
    .notification{
        height: 100%;
    }
    #xButt{
        background-color: #666 !important;
    }

</style>
